import ProgramListSelector from './ProgramListSelector';

export default ProgramListSelector;
